import { render, staticRenderFns } from "./BookingArticleLine.vue?vue&type=template&id=71550af4&"
import script from "./BookingArticleLine.vue?vue&type=script&lang=js&"
export * from "./BookingArticleLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports